import React, { useEffect, useRef, useState } from "react";
import { Data, StepData, VideoInterface } from "../../../Context";
import StepResultCard from "../StepResultCard";
import { Area, AreaChart, ResponsiveContainer, Tooltip, XAxis } from "recharts";
import { MediaPlayer, MediaPlayerInstance, MediaProvider, useStore } from "@vidstack/react";

interface Props {
    step : StepData;
    magnetData : Data,
    video : VideoInterface,
    idx : number,
    created_date : string,
}

const VideoStepResults = ({ step, video, idx, magnetData, created_date } : Props) : React.ReactElement => {
    const [timeLeft, setTimeLeft] = useState<number | undefined>(undefined);
    const VideoRef = useRef<MediaPlayerInstance>(null), {playing} = useStore(MediaPlayerInstance, VideoRef);
    const mobile = false;

    const timeUpdate = () => {
        if(VideoRef.current?.currentTime){
        if(VideoRef.current.duration){
            if(video.timeLeftPersentage){
                if((VideoRef.current.currentTime / VideoRef.current.duration) * 100 >= video.timeLeftPersentage){
                    setTimeLeft(Number((VideoRef.current.duration - VideoRef.current.currentTime).toFixed(0)))
                }else{
                    setTimeLeft(undefined);
                }
            }
        }
        }
    }

    useEffect(()=>{
    },[video.CTAscreen, video.textScreenStyle.backgroundColor])

    let viewResults : number[] = [];
    let ViewPercentages : any[] = [];

    const formatVideoData = () => {
        if(step.start > 0){
            for(let start = 0; start <= step.start ; start ++){
                viewResults.push(100);
            }
            if(viewResults.length > step.start){
                viewResults.pop();
            }
        }

        if(step.pauseList){

            for(let pop = 1; pop <= step.pauseList.length; pop ++){
                viewResults.pop();
            }

            step.pauseList.sort()
            step.pauseList.forEach((pause : number) => {
                viewResults.push(Number(pause));
            });
        }

        viewResults.sort((a:number, b:number) => a-b);

        for(let counter = 0; counter <= 100; counter ++){
            let addition = {percentage : counter + "%", views : 0};
            viewResults.forEach((result : number) => {
                if(result >= counter){
                    addition.views += 1;
                }
            });
            ViewPercentages.push(addition);
        }
        if(ViewPercentages[100].views > step.finish){
            ViewPercentages[100].views = step.finish;
        }
    }

    formatVideoData();

    return(
    <div key={idx} className="bg-brandLightGray p-5 mt-5 mb-5 flex lg:flex-row max-lg:flex-col flex-wrap rounded-xl gap-3 justify-start items-center">
        <p className="text-xl font-bold w-full">Step {idx + 1}: <span className="font-normal">Video</span></p>
        <div className="w-full flex flex-col gap-2">
            <div className="flex flex-row xl:w-full gap-3">
                {
                    (idx === 0)

                    ?<StepResultCard title="Video Starts" 
                    color={`${(step.view && (step.start / step.view) * 100 > 20)?"bg-green":(step.view && (step.start / step.view) * 100 > 10)?"bg-yellow":"bg-red"}`} 
                    textColor={`${(step.view && (step.start / step.view) * 100 > 20)?"text-white":(step.view && (step.start / step.view) * 100 > 10)?"text-black":"text-white"}`}
                    result={(step.start) ? step.start : 0} percentage={false} 
                    comparison={(magnetData.stepsComparison[idx]) ? magnetData.stepsComparison[idx].start : 0} loadign={false}/>

                    :<StepResultCard title="Video Starts" 
                    color={`${(step.start && step.start > 0)?"bg-green":"bg-red"}`} textColor="text-white"
                    result={(step.start) ? step.start : 0} percentage={false} 
                    comparison={(magnetData.stepsComparison[idx]) ? magnetData.stepsComparison[idx].start : 0} loadign={false}/>
                }

                <StepResultCard title="Video Finishes" 
                color={`${(step.finish && (step.finish / step.start) * 100 > 50)?"bg-green":((step.finish / step.start) * 100 > 25)?"bg-yellow":"bg-red"}`} 
                textColor={`${(step.finish && (step.finish / step.start) * 100 > 50)?"text-white":((step.finish / step.start) * 100 > 25)?"text-black":"text-white"}`}
                result={(step.finish) ? step.finish : 0} percentage={false} 
                comparison={(magnetData.stepsComparison[idx]) ? magnetData.stepsComparison[idx].finish : 0} loadign={false}/>

                <StepResultCard title="Completion Rate" 
                color={`${(step.finish && (step.finish / step.start) * 100 > 50)?"bg-green":((step.finish / step.start) * 100 > 25)?"bg-yellow":"bg-red"}`} 
                textColor={`${(step.finish && (step.finish / step.start) * 100 > 50)?"text-white":((step.finish / step.start) * 100 > 25)?"text-black":"text-white"}`}
                result={(step.finish) ? (step.finish / step.start)*100 : 0} percentage={true} 
                comparison={(magnetData.stepsComparison[idx]) ? magnetData.stepsComparison[idx].finish / magnetData.stepsComparison[idx].start * 100 : 0} loadign={false}/>
            </div>
            {
                (!isNaN(Date.parse(created_date)))
                ?<div className={`${"w-full"} rounded-lg flex justify-center items-center shadow-md`}>
                    <MediaPlayer playsInline className='relative w-full h-full flex justify-center items-center rounded-lg' ref={VideoRef}
                    title='CX Tailor video' src={video.url} onTimeUpdate={timeUpdate} autoPlay={false} muted={true}>
                    <MediaProvider className="rounded-lg">
                    </MediaProvider>
                    {
                        (timeLeft !== undefined && video.showTimeLeft)
                        ?<div className={`absolute ${(video.teaserStyle.y === "top")?"top-5":"bottom-5"} ${(video.teaserStyle.x === "right")?"right-0":"left-0"} pr-10`} 
                        style={{
                            backgroundColor : `${video.teaserStyle.backgroundColor}`,
                            padding : `${(!mobile)? video.teaserStyle.padding + "rem" : video.teaserStyle.padding/2 + "rem"}`,
                        }}>
                        <p style={{
                            color : `${video.teaserStyle.color}`,
                            fontSize : `${(!mobile)? video.teaserStyle.size + "rem" : video.teaserStyle.size / 2 + "rem"}`
                        }}>{video.timeLeftText} {timeLeft} s</p>
                        </div>
                        :null
                    }
                    <div className={`absolute z-10 rounded-lg w-[calc(100%+5px)] h-[calc(100%+5px)] flex justify-center items-end`} >
                        <ResponsiveContainer height={(ViewPercentages[0].views === ViewPercentages[98].views)?"50%":"100%"} width={"100%"}>
                            <AreaChart width={(window.innerWidth)} height={250} data={ViewPercentages} onMouseMove={
                                (e)=>{
                                    if(VideoRef.current){
                                        VideoRef.current.currentTime = VideoRef.current.duration * (e.activeTooltipIndex! / 100);
                                    }
                                }
                            }>
                                <defs>
                                    <linearGradient id="colorView" x1={0} x2={0} y1={0} y2={1}>
                                        <stop offset="5%" stopColor="#6156A5" stopOpacity={1}/>
                                        <stop offset="95%" stopColor="#6156A5" stopOpacity={1}/>
                                    </linearGradient>
                                </defs>
                                <XAxis dataKey="percentage" hide={true}/>
                                <Tooltip cursor={{stroke : "#6156A5", strokeWidth : 2}}/>
                                <Area type="monotone" dataKey="views" stackId="1" stroke="#6156A5" fill="url(#colorView)" fillOpacity={0.6}/>
                            </AreaChart>
                        </ResponsiveContainer>
                    </div>
                    </MediaPlayer>
                </div>
                :null
            }
        </div>
    </div>
    );
};

export default VideoStepResults;